import { cx } from 'src/utils/cx'
import IcBaselineExplicit from '~icons/ic/baseline-explicit'

export function NsfwBlurForImage(
  props: StyleProps & { iconProps?: StyleProps },
) {
  return (
    <div
      className={cx(
        'absolute w-full h-full bg-black/40 top-0 left-0 backdrop-blur-md flex items-center justify-center',
        props.className,
      )}
    >
      <IcBaselineExplicit
        className={cx('opacity-50', props.iconProps?.className)}
      ></IcBaselineExplicit>
    </div>
  )
}
